import { render, staticRenderFns } from "./GoodsAttributeEdit.vue?vue&type=template&id=3c3d58bd&"
import script from "./GoodsAttributeEdit.vue?vue&type=script&lang=js&"
export * from "./GoodsAttributeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports